import React from 'react';
import styles from './index.module.scss';
import Card from '@components-clean/core/card';

export type SubjectProfileMiniWidgetSingleValueProps = {
    'data-testid': string;
    icon?: React.ReactNode;
    label: string;
    value: string | number | null | undefined;
};

const SubjectProfileMiniWidgetSingleValue = ({
    'data-testid': dataTestId,
    icon,
    label,
    value,
}: SubjectProfileMiniWidgetSingleValueProps) => {
    return (
        <Card data-testid={dataTestId} bodyClassName={styles.miniWidgetBody}>
            {icon}

            <span className={styles.miniWidgetLabel}>{label}:</span>

            <span className={styles.miniWidgetValue}>{value}</span>
        </Card>
    );
};

export default SubjectProfileMiniWidgetSingleValue;
